<script lang="ts" setup>
import Modal from "~/components/ui/modals/Modal.vue";
import useMainStore from "~/shared/store";
import AppButton from "~/components/ui/buttons/AppButton.vue";

defineProps<{
  text: string
}>();

const mainStore = useMainStore()

function handleDeletedUserModalApply() {
  mainStore.setDeletedUserModalState(false)
}
</script>

<template>
<Modal
  :modal-is-open="mainStore.isDeletedUserModal"
  @close-modal="mainStore.setDeletedUserModalState(false)"
>
  <p class="modal__txt" v-html="text"></p>
  <noindex>
    <AppButton
      text="Понятно"
      @click="handleDeletedUserModalApply"
    />
  </noindex>
</Modal>
</template>

<style lang="scss" scoped>
.modal {
  :deep(.modal-content) {
    max-width: 544px;
    min-width: 300px;
    @include xs-breakpoint {
      width: 100%;
    }
  }

  &__txt {
    margin-top: 12px;
    :deep(a) {
      color: $control-content_orange;
      transition: color .3s ease;

      &:hover {
        color: $control-content_orange-hover;
      }
    }
  }

  button {
    margin-top: 28px;
    @include md-breakpoint {
      width: 100%;
    }
  }
}
</style>
